"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
const themes_1 = require("../../themes");
const theme = (0, themes_1.SelectTheme)('grupo', themes_1.grupoTheme);
exports.default = {
    Wrapper: styled_components_1.default.div `
    position: relative;

    .modal-main {
      background: ${theme.colors.build.light.dark.secondary};
    }

    .modal-header {
      &-title {
        color: ${theme.colors.build.dark.default};
      }

      svg {
        fill: ${theme.colors.build.dark.default};
      }
    }
  `,
    Items: styled_components_1.default.div `
    display: flex;
    padding-top: ${theme.spaces.sp2};
    justify-content: flex-start;
  `,
    ItemsSingle: styled_components_1.default.button((props) => {
        const { colorIcon } = props;
        let colorShared;
        switch (colorIcon) {
            case 'whatsapp':
                colorShared = theme.colors.support.whatsapp;
                break;
            case 'facebook':
                colorShared = theme.colors.support.facebook;
                break;
            default:
                colorShared = `linear-gradient(90deg, ${theme.colors.action.gradient.navigation.first}, ${theme.colors.action.gradient.navigation.end})`;
                break;
        }
        return `
      background: transparent;
      border: none;
      padding: 0;
      margin-right: ${theme.spaces.sp4};
      width: 80px;
      a {
        text-decoration: none;
      }
      dl {
        align-items: center;
        color: ${theme.colors.action.navigation.alt.static};
        display: flex;
        flex-direction: column;
        dt{
          align-items: center;
          background: ${colorShared};
          border-radius: ${theme.decoration.radius.pill};
          display: flex;
          height: 48px;
          justify-content: center;
          margin-bottom: ${theme.spaces.sp2};
          width: 48px;
          svg {
            font-size: 20px;
          }
        }
        dd{
          ${theme.type.bodyLargeShortRegular}
          color: ${theme.colors.build.dark.light};
        }
      }
    `;
    }),
};
